import { render } from "./definitionBuilderQuestion.vue?vue&type=template&id=678a0dcd"
import script from "./definitionBuilderQuestion.vue?vue&type=script&lang=js"
export * from "./definitionBuilderQuestion.vue?vue&type=script&lang=js"

import "./definitionBuilderQuestion.vue?vue&type=style&index=0&id=678a0dcd&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__